// project imports
import services from 'utils/mockAdapter';

// user list
const dashboard = {
    id: 'dashboard',
    title: 'dashboard',
    icon: 'dashboard',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard/default',
            icon: 'dashboard',
            breadcrumbs: false
        }
    ]
};

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/dashboard').reply(200, { dashboard });
